import './UserManagement.css';

const UserManagement: React.FC = () => {
  return (
    <h2>Hi, I am UserManagement!</h2>
  );
};

export default UserManagement;